export default {
  '_b._qhyy': '언어 전환',

  '_a._jzz': '로딩 중...',
  '_a._jzgd': '더보기',
  '_a._wct': '환영합니다',
  '_a._gd': '더보기',
  '_a._bf': '재생',
  '_a._bcz': '저장 중...',
  '_a._sctp': '이미지 업로드',

  '_dl._qssyx': '이메일을 입력해주세요',
  '_dl._qssmm': '비밀번호를 입력해주세요',
  '_dl._ann': '로그인',
  '_dl._hmyzh': '계정이 없으신가요?',
  '_dl._qzc': '회원가입',
  '_dl._yzhl': '이미 계정이 있으신가요?',
  '_dl._qdl': '로그인',
  '_dl._srqrmm': '비밀번호를 확인해주세요',
  '_dl._sryqm': '초대 코드를 입력해주세요',
  '_dl._sryzm': '인증 코드를 입력해주세요',
  '_dl._ljzc': '지금 가입하기',
  '_dl._zcbsty': '가입 시 다음 내용을 읽고 동의한 것으로 간주됩니다',
  '_dl._yszc': '개인정보처리방침',
  '_dl._lcmmbyy': '비밀번호가 일치하지 않습니다',

  '_yzm._fsyzm': '인증 코드 전송',
  '_yzm._cxfs': '({time}) 다시 전송',
  '_yzm._fsz': '전송 중...',
  '_yzm._fscg': '전송 성공',

  '_h._zrm': '인기',
  '_h._zxd': '최신',
  '_h._phb': '순위',
  '_h._qz': '배경화면',
  '_h._ssww': '검색',
  '_h._lsjl': '히스토리',
  '_h._gd': '더보기',
  '_h._dl': '로그인',
  '_h._ye': '잔액',
  '_h._dj': '동결',
  '_h._ybp': '대시보드',
  '_h._wdqb': '내 지갑',
  '_h._scjl': '찜하기',
  '_h._xxzx': '메시지 센터',
  '_h._fxhy': '친구 공유',
  '_h._bzzx': '고객센터',
  '_h._ggtf': '광고 게재',
  '_h._bqtz': '저작권 투자',
  '_h._sz': '설정',

  '_sy._jx': '추천',
  '_sy._xpfb': '신규 출시',
  '_sy._gdsp': '더 많은 영상',

  '_qz._jbqz': '정교한 배경화면 컬렉션',
  '_qz._ssqz': '배경화면 검색',
  '_qz._qb': '전체',
  '_qz._zrfg': '자연 경관',
  '_qz._cxys': '추상 미술',
  '_qz._csjz': '도시 건축',
  '_qz._dmyx': '애니메이션 & 게임',
  '_qz._yzxk': '우주와 별',
  '_qz._yl': '미리보기',
  '_qz._xzqz': '배경화면 다운로드',
  '_qz._fbl': '해상도',
  '_qz._fl': '카테고리',
  '_qz._jzz': '로딩 중',
  '_qz._myzdpp': '일치하는 배경화면을 찾을 수 없습니다',

  '_sp._xyjscl': '시청하려면 잠금 해제가 필요합니다',
  '_sp._cz': '충전',
  '_sp._jsqj': '모든 에피소드 잠금 해제',
  '_sp._jsbj': '이 에피소드 잠금 해제',
  '_sp._sc': '찜하기',
  '_sp._fx': '공유',
  '_sp._jsqjjs': '{a} 결제 후 모든 에피소드를 잠금 해제하시겠습니까?',
  '_sp._jsbjjs': '{a} 결제 후 이 에피소드를 잠금 해제하시겠습니까?',
  '_sp._zfz': '결제 처리 중...',
  '_sp._qrzf': '결제 확인',
  '_sp._qx': '취소',

  '_qz._smrc': '산간 일출',
  '_qz._cxjh': '추상 기하학',
  '_qz._dsyj': '도시 야경',
  '_qz._dmfj': '애니메이션 풍경',
  '_qz._hhxk': '광활한 별빛',
  '_qz._slmw': '숲 안개',
  '_qz._scld': '색상 흐름',
  '_qz._xdjz': '현대 건축',

  '_qb._cbjl': '입금 기록',
  '_qb._jyjl': '거래 기록',
  '_qb._bddz': '등록 주소',
  '_qb._txjl': '출금 기록',

  '_m._tcdl': '로그아웃',
  '_m._cb': '입금',
  '_m._tb': '출금',

  '_cb._ssdz': '통화 또는 주소 검색',
  '_cb._bz': '통화',
  '_cb._je': '금액',
  '_cb._dz': '주소',
  '_cb._sj': '시간',
  '_cb._cz': '작업',
  '_cb._zwjl': '아직 거래 기록이 없습니다',
  '_cb._dny': '{a} / {b} 페이지',
  '_cb._jyxq': '거래 상세',
  '_cb._jydz': '거래 주소',
  '_cb._zt': '상태',
  '_cb._yqr': '확인됨',
  '_cb._qb': '전체',
  '_cb._jt': '오늘',
  '_cb._j7t': '지난 7일',
  '_cb._j30t': '지난 30일',
  '_cb._zw': '없음',
  '_cb._fzcg': '주소가 클립보드에 복사되었습니다',

  '_jyjl._ssdz': '통화 또는 주소 검색',
  '_jyjl._lx': '유형',
  '_jyjl._je': '금액',
  '_jyjl._ye': '잔액',
  '_jyjl._dj': '동결',
  '_jyjl._sj': '시간',
  '_jyjl._cz': '작업',
  '_jyjl._zwjyjl': '아직 거래 기록이 없습니다',
  '_jyjl._czsx': '필터 초기화',
  '_jyjl._dny': '{a} / {b} 페이지',
  '_jyjl._jyxq': '거래 상세',
  '_jyjl._jylx': '거래 유형',
  '_jyjl._jyje': '거래 금액',
  '_jyjl._jyhye': '거래 후 잔액',
  '_jyjl._djye': '동결 금액',
  '_jyjl._jysj': '거래 시간',
  '_jyjl._jyzt': '거래 상태',
  '_jyjl._ywc': '완료',
  '_jyjl._qb': '전체',
  '_jyjl._jt': '오늘',
  '_jyjl._j7t': '지난 7일',
  '_jyjl._j30t': '지난 30일',

  '_jyjl._tp1': '입금',
  '_jyjl._tp2': '출금',
  '_jyjl._tp3': '결제',
  '_jyjl._tp4': '입금',
  '_jyjl._tp5': '동결',
  '_jyjl._tp6': '수익',
  '_jyjl._tp7': '추천 보상',
  '_jyjl._tp8': '로그인 보상',
  '_jyjl._tp9': '프로모션 수익',
  '_jyjl._tp10': '영상 시청 보상',
  '_jyjl._tp11': '가입 보너스',
  '_jyjl._tp12': '인출이 거부되었습니다',
  '_jyjl._tp13': '메시지 적포',

  '_jyjl._tp14': '내부 이체',

  '_cb._shz': '검토 중',
  '_cb._yyg': '승인됨',
  '_cb._ybh': '거부됨',

  '_bddz._tjdz': '주소 추가',
  '_bddz._ssdz': '주소 검색',
  '_bddz._bz': '통화',
  '_bddz._dz': '주소',
  '_bddz._sysj': '마지막 사용',
  '_bddz._cz': '작업',
  '_bddz._zwjl': '아직 주소 기록이 없습니다',
  '_bddz._dny': '{a} / {b} 페이지',
  '_bddz._dzewm': '주소 QR 코드',
  '_bddz._fzdz': '주소 복사',
  '_bddz._dzxq': '주소 상세',
  '_bddz._wl': '네트워크',
  '_bddz._tjsj': '추가 시간',
  '_bddz._bzwa': '메모',
  '_bddz._ntq': '{a}일 전',
  '_bddz._nxsq': '{a}시간 전',
  '_bddz._nfzq': '{a}분 전',
  '_bddz._ngg': '방금',
  '_bddz._dzyfz': '주소가 클립보드에 복사되었습니다',
  '_bddz._scqr': '삭제 확인',
  '_bddz._scqrdz': '이 주소를 삭제하시겠습니까?',
  '_bddz._qr': '확인',
  '_bddz._qx': '취소',
  '_bddz._scdzcg': '주소 삭제 성공',

  '_txjl._ztsx': '상태 필터',
  '_txjl._qbzt': '모든 상태',
  '_txjl._shz': '검토 중',
  '_txjl._ytg': '승인됨',
  '_txjl._yjj': '거부됨',
  '_txjl._ssdz': '주소 또는 금액 검색',
  '_txjl._bz': '통화',
  '_txjl._je': '금액',
  '_txjl._dz': '주소',
  '_txjl._zt': '상태',
  '_txjl._sj': '시간',
  '_txjl._cz': '작업',
  '_txjl._zwjl': '아직 거래 기록이 없습니다',
  '_txjl._czsx': '필터 초기화',
  '_txjl._dny': '{a} / {b} 페이지',
  '_txjl._jyxq': '거래 상세',
  '_txjl._skdz': '수신 주소',
  '_txjl._jysj': '거래 시간',
  '_txjl._jyzt': '거래 상태',
  '_txjl._fzdz': '주소가 클립보드에 복사되었습니다',

  '_cbsq._bz': '통화',
  '_cbsq._wl': '네트워크',
  '_cbsq._erwm': 'QR 코드',
  '_cbsq._fzdz': '주소 복사',

  '_txsq._bz': '통화',
  '_txsq._wl': '네트워크',
  '_txsq._ye': '잔액',
  '_txsq._sxf': '수수료',
  '_txsq._zxtx': '최소 출금액',
  '_txsq._txdz': '출금 주소',
  '_txsq._qxztxdz': '출금 주소를 선택해주세요',
  '_txsq._txje': '출금 금액',
  '_txsq._qsrtxje': '출금 금액을 입력해주세요',
  '_txsq._yxyzm': '이메일 인증 코드',
  '_txsq._qsryxyzm': '인증 코드를 입력해주세요',
  '_txsq._ljtx': '지금 출금',

  '_jl._wxhd': '내 찜',
  '_jl._lsjl': '히스토리',

  '_xx._bt': '메시지 센터',
  '_xx._wjl': '기록 없음',
  '_xx._zsmyxx': '아직 메시지가 없습니다',
  '_xx._sxxx': '메시지 새로고침',
  '_xx._sxcg': '새로고침 성공',

  '_fx._fxhy': '친구 공유',
  '_fx._smfx': 'QR 코드 스캔하여 친구와 공유',
  '_fx._jlsm': '보상 설명',
  '_fx._jlsm1': '1. 직접 초대한 친구(1단계)로부터 수익의 {a}%를 획득',
  '_fx._jlsm2': '2. 1단계 친구가 초대한 친구(2단계)로부터 수익의 {a}%를 획득',
  '_fx._jlsm3': '3. 2단계 친구가 초대한 친구(3단계)로부터 수익의 {a}%를 획득',
  '_fx._fzlj': '링크 복사',

  '_bzzx._bzzx': '고객센터',
  '_bzzx._rhzczh': '계정 생성 방법',
  '_bzzx._zclc': '가입 절차',
  '_bzzx._rhzcxyh': '새 계정을 등록하는 방법',
  '_bzzx._rhzcxyh1': ' "가입" 버튼을 클릭하고 이메일 주소를 입력하고 비밀번호를 설정한 후 이메일 인증을 완료하여 계정을 등록하세요.',
  '_bzzx._rhcz': '충전 방법',
  '_bzzx._rhcz1': '충전 절차',
  '_bzzx._rhcz2': '자세한 충전 설명',
  '_bzzx._rhcz3': '내 지갑을 클릭하고 입금을 선택한 후 원하는 암호화폐를 선택하고 제공된 주소로 보냅니다.',

  '_bzzx._rhjsdj': '단편 드라마 잠금 해제 방법',
  '_bzzx._rhjsdj2': '개별 에피소드를 잠금 해제하려면 클릭하고 더 많은 콘텐츠를 시청하세요.',

  '_bzzx._rhtx': '계정에서 출금하는 방법',
  '_bzzx._rhtx1': '1. 내 지갑, 출금 주소로 이동하여 해당 암호화폐에 대한 새 출금 주소를 추가합니다.<br>2. 출금을 클릭하고 암호화폐를 선택하고 등록된 주소를 선택하고 출금 금액을 입력한 후 도착을 기다립니다.',

  '_bzzx._qtwt': '기타 질문',
  '_bzzx._qtwt1': '고객 서비스에 문의하는 방법',
  '_bzzx._qtwt2': '웹사이트 오른쪽 하단의 온라인 고객 서비스, 고객 서비스 이메일 또는 핫라인을 통해 문의할 수 있습니다.',
  '_bzzx._myzdwt': '찾고 있는 답변을 찾지 못하셨나요?',
  '_bzzx._khjybbzn': '저희 고객 서비스 팀이 추가로 도움을 드리겠습니다.',
  '_bzzx._lxkf': '고객서비스 문의',

  '_ggtf._bt1': '광고 게재',
  '_ggtf._splb': '영상 목록',
  '_ggtf._wcyd': '내 참여',
  '_ggtf._hdbm': '이벤트 코드',
  '_ggtf._tian': '일',
  '_ggtf._kssj': '시작 시간',
  '_ggtf._jssj': '종료 시간',
  '_ggtf._ddvp': 'VIP 레벨 {a} 달성, 1인당 평균 {b}회 참여',
  '_ggtf._hdzt': '이벤트 상태',
  '_ggtf._wks': '시작 전',
  '_ggtf._ycy': '참여함',
  '_ggtf._qg': '지금 구매',
  '_ggtf._mygdl': '더 이상 데이터 없음',
  '_ggtf._qgrtd': '구매자가 너무 많습니다. 나중에 다시 시도해 주세요',
  '_ggtf._hdxq': '이벤트 상세',
  '_ggtf._hdjs': '이벤트 설명',
  '_ggtf._cyyq': '참여 요구 사항',
  '_ggtf._zdtz': '최소 투자',
  '_ggtf._vpdj': 'VIP 레벨',
  '_ggtf._rjcy': '평균 참여 횟수',
  '_ggtf._gmje': '구매 금액',
  '_ggtf._qsrgmje': '구매 금액을 입력해주세요',
  '_ggtf._qx': '취소',
  '_ggtf._ljcy': '지금 참여',
  '_ggtf._ssjymm': '거래 비밀번호 입력',
  '_ggtf._qssjymm': '거래 비밀번호를 입력해주세요',
  '_ggtf._ji': '레벨',
  '_ggtf._ci': '회',
  '_ggtf._zdgm': '최소 구매 금액',
  '_ggtf._zggm': '최대 구매 금액',
  '_ggtf._zfz': '결제 처리 중...',

  '_wdtg._wjl': '아직 참여 기록이 없습니다',
  '_wdtg._tzje': '투자 금액',
  '_wdtg._zsy': '총 수익',
  '_wdtg._hdts': '이벤트 일수',
  '_wdtg._cysj': '참여 시간',
  '_wdtg._qzf': '결제하기',
  '_wdtg._jxz': '진행 중',
  '_wdtg._djszje': '미정산 총액',
  '_wdtg._gjb': '총 {a}건',
  '_wdtg._djs': '미정산',
  '_wdtg._zrsy': '어제 수익',
  '_wdtg._dbl': '주문형 비디오 조회수',
  '_wdtg._bfl': '재생 수',
  '_wdtg._wdsy': '내 수익',
  '_wdtg._bqffc': '저작권자 지분',
  '_wdtg._mr0djs': '어제 수익은 매일 0시에 정산',
  '_wdtg._jrsy': '오늘 수익',
  '_wdtg._mygd': '더 이상 데이터 없음',

  '_bqyy._bqyy': '저작권 협력 예약',
  '_bqyy._qrbq': '저작권 협력 예약 신청을 확인하시겠습니까?',
  '_bqyy._qx': '취소',
  '_bqyy._tjyy': '예약 제출',

  '_bqyy._spsq': '영상 저작권 협력 신청',
  '_bqyy._spsy': '저작권자와 함께 영상을 홍보하여 더 많은 트래픽과 수익을 창출하세요!',
  '_bqyy._ljyy': '지금 예약',
  '_bqyy._sphz': '영상 저작권 협력 신청이란 무엇인가요?',
  '_bqyy._sphzsm': '영상 저작권 협력 신청은 상호 이익을 위한 더 많은 홍보 기회를 제공합니다. 신청을 통해 저작권자의 인정을 받고 더 많은 노출과 수익을 얻을 기회를 가질 수 있습니다.',
  '_bqyy._sqhch': '저작권 협력의 이점',
  '_bqyy._llfz': '트래픽 지원',
  '_bqyy._llfzsm': '플랫폼 홍보 기회를 얻어 노출과 재생 수를 증가',
  '_bqyy._sytg': '수익 증대',
  '_bqyy._sytgsm': '더 높은 광고 수익 분배와 비즈니스 협력 기회 획득',
  '_bqyy._yxhz': '우선 협력',
  '_bqyy._yxhzsm': '플랫폼 공식 이벤트와 비즈니스 협력 프로젝트에 우선 참여',
  '_bqyy._yytj': '예약 조건',
  '_bqyy._sptg': '영상 광고 홍보 요구 사항',
  '_bqyy._sptgsm': '플랫폼 기준을 충족하는 최소 1개의 영상 홍보에 참여',
  '_bqyy._yysm': '예약 후 3영업일 이내에 직원이 연락드립니다',

  '_ybp._wdsy': '내 수익',
  '_ybp._dqye': '현재 잔액',
  '_ybp._jr': '오늘',
  '_ybp._jrzsy': '오늘 총 수익',
  '_ybp._ljzsy': '누적 총 수익',
  '_ybp._tgfh': '홍보 배당금',
  '_ybp._ljsy': '누적 수익',
  '_ybp._bqsy': '저작권 수익',
  '_ybp._yqfh': '초대 배당금',
  '_ybp._mrsy': '일일 수익',
  '_ybp._tgsy': '홍보 수익',

  '_tjdz._tjxd': '새 주소 추가',
  '_tjdz._xzbz': '통화 선택',
  '_tjdz._qbdz': '지갑 주소',
  '_tjdz._srdz': '지갑 주소를 입력해주세요',
  '_tjdz._qx': '취소',
  '_tjdz._bc': '저장',

  '_sz._smrz': '실명 인증',
  '_sz._rzlx': '인증 유형',
  '_sz._sfzzm': '신분증 앞면',
  '_sz._sfzfm': '신분증 뒷면',
  '_sz._zsxm': '실명',
  '_sz._qsrzsxm': '실명을 입력해주세요',
  '_sz._sfzhm': '신분증 번호',
  '_sz._qsrsfzhm': '신분증 번호를 입력해주세요',
  '_sz._yyzz': '사업자 등록증',
  '_sz._qymc': '기업명',
  '_sz._yyzzh': '사업자 등록번호',
  '_sz._qsrqymc': '기업명을 입력해주세요',
  '_sz._qsryyzzh': '사업자 등록번호를 입력해주세요',
  '_sz._qx': '취소',
  '_sz._tjrz': '인증 제출',
  '_sz._zt': '상태',
  '_sz._gr': '개인',
  '_sz._qy': '기업',
  '_sz._shz': '검토 중',
  '_sz._ytg': '승인됨',
  '_sz._ybh': '거부됨',

  '_mm._xgmm': '비밀번호 변경',
  '_mm._dqxg': '계정 보안을 위해 정기적으로 비밀번호 변경',
  '_mm._dqmm': '현재 비밀번호',
  '_mm._xmm': '새 비밀번호',
  '_mm._qrxmm': '새 비밀번호 확인',
  '_mm._qx': '취소',
  '_mm._qrxg': '변경 확인',

  '_jymm._xgjymm': '거래 비밀번호 변경',

  '_szzx._sz': '설정',
  '_szzx._yrz': '인증됨',
  '_szzx._wrz': '인증되지 않음',
  '_szzx._jymm': '거래 비밀번호',
  '_szzx._szjymm': '거래 비밀번호 설정 또는 변경',
  '_szzx._tcdl': '로그아웃',
  '_szzx._qdtcdl': '로그아웃하시겠습니까?',
  '_szzx._qrtc': '로그아웃 확인',
  '_szzx._qx': '취소',

  '_yj._gy': '회사 소개',

  '_yj._lxwm': '문의하기',

  '_yj._yszc': '개인정보처리방침',

  '_yj._yhxy': '이용자 계약',

  '_cd._gszz': '회사 자격',

  '_cd._wmyy': '저희는 업계 최고의 자격 및 인증을 보유하고 있으며, 사용자에게 합법적이고 안전하며 고품질의 비디오 서비스를 제공합니다.',

  '_cd._yyzz': '회사의 합법적 운영을 증명하는 유효한 증빙 자료로, 정식 등록 정보 및 사업 범위를 입증합니다.',

  '_cd._yyzz2': '플랫폼의 합법성 및 규정 준수를 보장하는 합법적으로 취득한 회사 인증 사업 허가증',

  '_bz._lxkf': '고객 서비스에 문의하시려면 아래를 클릭하시거나, 고객 서비스 이메일을 통해 문의해 주세요. 핫라인',

  '_sz._bjtx': '편집',

  '_sz._bjxx': '메시지 편집',

  '_sz._tx': '아바타',

  '_sz._bcun': '저장',

  '_db._zskf': '고객 지원 연결',
  '_db._zsry': '전담 상담사',
  '_db._wdq': '읽지 않음',
  '_db._ydq': '읽음',

  '_sc._sctp': '이미지 업로드',
  '_sc._xztp': '이미지 선택',
  '_sc._fstp': '이미지 전송',
  '_sc._qx': '취소',
  '_sc._hd': '확인',

  '_zcyl._zcbt': '가입 혜택',
  '_zcyl._djdkhb': '레드 팩 열기',
  '_zcyl._zclj': '가입 보너스',
  '_zcyl._hmyzh': '아직 계정이 없으신가요?',
  '_zcyl._qzc': '가입하기',
  '_zcyl._qxdjhb': '먼저 보상을 받아주세요',
  '_zcyl._qwzc': '가입하러 가기',
  '_zcyl._hbysy': '이미 사용된 보상',

  '_ggtg._qhz': '이동하기',
  '_ggtg._dqye': '현재 잔액',
  '_ggtg._qcz': '충전하기',
  '_ggtg._hzje': '이체 금액',
  '_ggtg._ljhz': '즉시 이체',
  '_ggtg._yebz': '잔액 부족',

  '_sq._bhbt': '거절됨',

  '_sq._bhyy': '거절 사유',

  '_xx._ntq': '{n}일 전',

  '_xx._nxsq': '{n}시간 전',

  '_xx._nfzq': '{n}분 전',

  '_xx._nggq': '방금 전',

  '_xx._djckgd': '더 보려면 클릭',

  '_ct._zt': '상태',

  '_ct._ljz': '연결 중',

  '_ct._ylj': '연결됨',

  '_ct._ltlieb': '채팅 목록',

  '_ct._bnhzj': '나 자신과 채팅할 수 없습니다',

  '_ct._cylb': '멤버 목록',

  '_hb._fhb': '세뱃돈',

  '_hb._dqye': '현재 잔액',

  '_hb._fsd': '보낸 사람',

  '_hb._hbje': '세뱃돈 금액',

  '_hb._qshuru': '세뱃돈 금액을 입력하세요',

  '_hb._ljfs': '지금 보내기',

  '_hb._hbz': "세뱃돈' 축복",
  '_hb._qshuruzhu': '축복을 입력해 주세요',

  '_sp._cuow': '1화부터 10화까지는 시청하려면 잠금 해제가 필요합니다.',

  '_bq._tzzq': '투자 기간',

  '_bq._zrsy': '어제 수익',

  '_bq._bqtz': '저작권 투자',

  '_bq._tzdj': '투자 금액',

  '_bq._zfjz': '24시간 이내에 결제해야 하며, 그렇지 않을 경우 포기로 간주됩니다!',

  '_bq._qzf': '결제하기',

  '_bq.jz': '마감일',

  '_bq._ljzf': '지금 결제',

  '_bq._sqbz': '신청서 내용 (선택 사항)',

  '_bq._sqbzsm': '신청서를 입력해 주세요',

  '_bq._zzsqz': "저작권 신청 진행 중, 대기 중' 검토...",

  '_app._xz': 'ReelShortBiz 애플리케이션 다운로드',

  '_app._smerm': 'QR 코드를 스캔하여 다운로드',

  '_app._xzbt': '다운로드',

  '_m._yhzz': '은행 송금',
  '_m._yhxx': '은행 정보',
  '_m._yhmz': '은행 이름',
  '_m._yhdz': '은행 주소',
  '_m._yhmc': '성명',
  '_m._yhzh': '계좌번호',
  '_m._yhlx': '유형',
  '_m._yhly': '라우팅',
  '_m._yhdm': '코드',
  '_m._yhbz': '비고',
  '_m._fzxx': '정보 복사',

  '_m._zts': '팁',

  '_m._zyd1': '1. 송금 시 수취인의 이름, 계좌번호, 은행 코드를 정확히 확인해 주십시오. 오류가 있을 경우 송금액이 손실될 수 있습니다.',

  '_m._zyd2': "2. 중개 은행 수수료 차감으로 인한 잔액 부족을 방지하기 위해 '송금인 부담' 옵션을 선택하시는 것을 권장합니다.",

  '_m._zyd3': '3. 송금은 일반적으로 1~3 영업일이 소요됩니다. 양해 부탁드립니다. 문의 사항이 있으시면 고객센터로 연락해 주십시오.',

  '_m._zyd4': '4. 기타 문의 사항이 있으시면 고객센터로 연락해 주십시오.',

  '_m._jyh': '거래 번호',

  '_m._jyje': '금액',

  '_sp._dbye': 'VOD 잔액',
  '_sp.hzye': '이체',
  '_sp._txje': '이체 금액',
  '_sp._qsrtxje': '이체 금액을 입력하세요',
  '_sp._ljhz': '즉시 이체',
  '_sp._yebz': '잔액 부족',
  '_sp._qshuru': '올바른 이체 금액을 입력하세요',
  '_sp._fanh': '돌아가기',

  '_sp._tliu': '광고 집행',
  '_sp._xzgj': '국가 선택',
  '_sp._cdcw': '비디오 인코딩 오류',
  '_ggtf._hot': '인기',
  '_tl._tlsj': '집행 시간',
  '_tl._xzxb': '성별 선택',
  '_tl._nan': '남성',
  '_tl._nv': '여성',
  '_tl._hunhe': '혼합',
  '_tl._xznl': '연령 선택',
  '_sp._us': '미국',
  '_sp._en': '영국',
  '_sp._jp': '일본',
  '_sp._fr': '프랑스',
  '_sp._kr': '한국',
  '_sp._de': '독일',
  '_sp._id': '인도',
  '_sp._in': '인도네시아',
  '_sp._au': '호주',
  '_sp._es': '스페인',
  '_sp._my': '말레이시아',
  '_sp._cn': '중국',
  '_ggtf._fanhui': '뒤로',
  '_ggtf._jymmts': '거래 금액을 확인하고 비밀번호를 입력하세요',
  '_wdtg._wjl_desc': '아직 광고 캠페인에 참여하지 않았습니다',
  '_wd._jxz': '진행 중',
  '_wd._djs': '정산 대기',
  '_wd._ywc': '완료',
  '_wd._jz': '긴급',
  '_wd._hz': '이체',

  '_tl._tlfbqk': '광고비 분포 현황',
  '_tl._tlfbqk_desc': '1-5일:5%(콜드 스타트 기간), 6-10일:20%(콘텐츠 검증 기간), 11-15일:40%(IP 구축 기간), 16-20일:35%(숏드라마 매트릭스 기간)',

  '_nhz._sm': '송금 후 금액은 비디오 콘텐츠 잠금 해제를 위해 비디오 지갑으로 이체됩니다',
  '_nhz._zhzz': '송금 중...',
  '_nhz._zzcg': '송금 성공',
  '_nhz._zhzsb': '송금 실패, 다시 시도해주세요',
  '_m._fzcg': '복사 성공',
  '_m._fzsb': '복사 실패, 수동으로 복사해주세요',
  '_m._zwfzxx': '복사할 정보가 없습니다',
  '_tx._qb': '전체',
  'activity.detail': '활동 상세',
  'activity.noDesc': '활동 설명이 없습니다',
  'activity.desc': '활동 설명',
  'activity.requirements': '참여 요건',
  'activity.minInvest': '최소 투자금',
  'activity.vipLevel': 'VIP 레벨',
  'activity.avgParticipation': '평균 참여',
  'activity.avgParticipationDesc': '회',
  'activity.country': '국가 선택',
  'activity.deliveryTime': '광고 집행 시간',
  'activity.deliveryTimeDesc': '일',
  'activity.gender': '성별 선택',
  'activity.male': '남성',
  'activity.female': '여성',
  'activity.mixed': '혼합',
  'activity.age': '연령 선택',
  'activity.amount': '구매 금액',
  'activity.back': '뒤로',
  'activity.join': '지금 참여',
  emptyData: '데이터 없음',
  emptyDataDesc: '참여 중인 광고 캠페인이 없습니다',
  completedtlement: '만료됨',
  preheat: '예열 중',
  progress: '진행 중',
  settlement: '정산 대기',
  transfered: '이체 완료',
  completed: '완료',
  activityCode: '활동 코드',
  touzAmount: '투자 금액',
  activityDays: '활동 일수',
  joinTime: '참여 시간',
  playSource: '재생 소스 분포',
  allPlatforms: '모든 플랫폼',
  other: '기타',
  totalPlayNum: '총 재생 수',
  incomeSummary: '수익 요약',
  totalPay: '지불한 저작권료',
  totalIncome: '총 수익',
  copyrightRatio: '저작권자 분배 비율',
  promotionIncome: '프로모션 수익',
  copyrightIncome: '저작권 분배',
  playNum: '재생 수',
  buyNum: '주문형 재생 수',
  incomeRate: '분배 비율',
  yjIncome: '예상 수익',
  paid: '지불 완료',
  timeout: '시간 초과',
  transfer: '지금 이체',
  loading: '로딩 중...',
  loadMore: '더 보기',
  noMore: '더 이상 없습니다',
  nightTime: '심야 시간대',
  morningTime: '오전 시간대',
  afternoonTime: '오후 시간대',
  eveningTime: '저녁 시간대',
  '_h._tc': '로그아웃',
  periodPayment: '기간별 결제',
  periodPaymentDesc: '하루 4회, 4개 기간으로 정산되며, 기간별로 저작권료를 지불할 수 있습니다',

  day: '일',
  '_dl._hy': '돌아오신 것을 환영합니다',
  '_dl._cj': '계정 만들기',
  '_dl._zmm': '비밀번호 재설정',
  '_dl._hyDesc': '계정에 로그인하여 훌륭한 콘텐츠를 계속 탐색하세요',
  '_dl._cjDesc': 'ReelShortBiz에 가입하고 흥미진진한 여정을 시작하세요',
  '_dl._zmmDesc': '이메일을 입력하시면 재설정을 위한 인증 코드를 보내드립니다',
  '_dl._hlgqsp': '방대한 HD 영화 및 비디오 리소스',
  '_dl._gxhty': '맞춤형 추천 알고리즘',
  '_dl._ffddsp': '다양한 숏폼 비디오',
  '_dl._dlzh': '로그인',
  '_dl._sdndyx': '이메일과 비밀번호를 입력하여 계속하세요',
  '_dl._email': '이메일 주소',
  '_dl._qsryx': '이메일 주소를 입력하세요',
  '_dl._dlmm': '비밀번호',
  '_dl._qsrmm': '비밀번호를 입력하세요',
  '_dl._wjmm': '비밀번호를 잊으셨나요?',
  '_dl._immdl': '지금 로그인',
  '_dl._hmyzh2': '계정이 없으신가요?',
  '_dl._ljzc2': '지금 가입하기',
  '_dl._cjzh': '계정 만들기',
  '_dl._jswmd': 'ReelShortBiz에 가입하고 흥미진진한 여정을 시작하세요',
  '_zh._qszmm': '비밀번호를 설정하세요',
  '_zh._qrmm': '비밀번호 확인',
  '_zh._qmm': '비밀번호를 다시 입력하세요',
  '_zc._yqm': '초대 코드',
  '_zc._sryqm': '초대 코드를 입력하세요',
  '_dl._yzm': '인증 코드',
  '_dl._qsryzm': '인증 코드를 입력하세요',
  '_dl._yjyzh': '이미 계정이 있으신가요?',
  '_dl._zcbsty2': '가입함으로써 귀하는 다음에 동의합니다',
  '_dl._zcbstyDesc': '개인정보 처리방침',
  '_dl._newmm': '새 비밀번호',
  '_dl._qszxmm': '새 비밀번호를 설정하세요',
  '_dl._qrmm': '비밀번호 확인',
  '_dl._qzcsrmm': '새 비밀번호를 다시 입력하세요',
  '_dl._czmm': '비밀번호 재설정',
  '_dl._xqlmm': '비밀번호가 생각나셨나요?',
  '_dl._fhdl': '로그인으로 돌아가기',
  '_dl._srdllmmbyz': '비밀번호가 일치하지 않습니다',
  '_dl._czcg': '비밀번호가 성공적으로 재설정되었습니다',
  '_h._zc': '가입',
  // '_ybp._wdsy': '내 수익',
  '_ybp._jrsy': '오늘의 수익',
  '_ybp._jztr': '어제 대비',
  '_ybp._bfl': '조회수',
  '_ybp._dbl': '요청수',
  '_ybp._syqs': '수익 추세',
  // '_ybp._jr': '오늘',
  '_ybp._t': '일',
  // '_ybp._dqye': '계정 잔액',
  '_ybp._djs': '미정산',
  '_ybp._zhl': '전환율',
  '_ybp._sjgl': '데이터 개요',
  '_ybp._zrsy': '어제의 수익',
  '_ybp._bysy': '이번 달 수익',
  '_ybp._yysj': '운영 데이터',
  '_ybp._zr': '어제',
  '_ybp._zjfrs': '총 유료 사용자 수',
  '_ybp._mtdqje': '내일 입금 예정 금액',
  '_ybp._jsy': '순수익',
  '_ybp._bqfy': '저작권료 지불 계획',
  '_ybp._yzf': '지불 완료',
  '_ybp._qzf': '지불하기',
  '_ybp._bqfyts': '저작권료 지불 후 수익과 권리가 우선적으로 보호됩니다',
  '_ybp._syjl': '수익 내역',
  '_ybp._ckgd': '더 보기',
  '_ybp._ssdt': '실시간 업데이트',
  '_ybp._bzzx': '고객센터',
  '_ybp._lxkf': '고객 지원',
  '_ybp._zrxz': '어제의 수익',
  '_ybp._zdsy': '총 수익',
  '_ybp._qygy': '지난 달',
  '_ybp._jsjl': '정산 내역',
  '_ybp._hzjl': '이체 내역',
  '_ybp._jfzq': '분 전',
  '_ybp._fzq': '시간 전',
  '_ybp._djs_mt': '내일 정산 금액',
  '_yj._rule': '플랫폼 규칙',

  '_bq._jjks': '지금 시작',
  '_bq._jxz': '진행 중',
  '_bq._jks': '시작까지',
  '_bq._jjs': '종료까지',
  '_bq._t': '일',
  '_bq._h': '시',
  '_bq._m': '분',
  '_bq._s': '초',
  '_bq._kssj': '시작 시간',
  '_bq._jssj': '종료 시간',
  '_bqq._tzdj': '단가',
  '_bqq._hdts': '이벤트 기간',
  '_bqq._vip': 'VIP 등급',
  '_bqq._rjcy': '평균 참여',
  '_bqq._cs': '회',
  '_bqq._ysjd': '판매 진행률',
  '_bqq._ljqg': '지금 구매',
  '_bqq._zbkqg': '현재 구매 불가',
  '_bqq._jzz': '로딩 중',
  '_bqq._jzgd': '더 불러오기',
  '_bqq._wz': '더 이상 없음',

  '_sp._gdsj': '총 {n}화',
  '_sy._jl': '미결제 기록',
  '_ybp._zsy': '총 수익',
  '_ybp._djsjl': '미결제 기록',
  '_ybp._bqbm': '코드',
  '_ybp._je': '금액',
  '_ybp._sj': '시간',
  '_sy._djs': '미결제',
  '_sy._yjs': '결제 완료',
  '_sy._gdstjl': '총 {n}개 기록',
  '_sy._gjd': '총 {n}개',

  '_sp.tgdy':'금액은 {a}보다 낮을 수 없습니다',
  '_sp.tggy':'금액은 {a}보다 높을 수 없습니다',

  '_tg._zdyje': '사용자 지정 금액'
}
